"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingKeys = void 0;
var OnboardingKeys;
(function (OnboardingKeys) {
    OnboardingKeys["AIStructureSuggestions"] = "AIOnboardingStructureSuggestions";
    OnboardingKeys["EditModuleCover"] = "EditModuleCover";
})(OnboardingKeys || (exports.OnboardingKeys = OnboardingKeys = {}));
const useOnboarding = (onboardingKey) => {
    const isViewed = () => {
        const item = window.localStorage.getItem(onboardingKey);
        return Boolean(item);
    };
    const setOnboardingView = () => {
        window.localStorage.setItem(onboardingKey, new Date().toUTCString());
    };
    return {
        showOnboarding: !isViewed(),
        setOnboardingView
    };
};
exports.default = useOnboarding;
